import * as React from "react"
import { Dialog as MuiDialog, DialogTitle, DialogContent, Button, DialogContentText, DialogActions } from '@mui/material';

import { useLocation } from "@reach/router"

import { ReactComponent as Close } from 'images/icons/close.svg';

const Dialog = (props) => {
	const dialogProps = {
		...props,
		variant: 'dialog'
	};
	const onClose = props.onClose;
	delete dialogProps.children;
	delete dialogProps.title;
	delete dialogProps.titleButtons;
	delete dialogProps.onClose;
	delete dialogProps.actions;

	const location = useLocation();
	const initialPathRef = React.useRef(location.pathname);
	const onCloseRef = React.useRef(onClose);
	onCloseRef.current = onClose;

	React.useEffect(() => {
		if (location.pathname === initialPathRef.current) return;
		initialPathRef.current = location.pathname;
		if (props.open && onCloseRef.current) onCloseRef.current({}, "routeChange");
	}, [location.pathname, props.open]);

	const handleClose = (evt) => {
		if (onClose)onClose(evt, "closeButtonClick");
	}

	const handleOnClose = (evt, reason) => {
		if (onClose)onClose(evt, reason);
	}

	const inlineStyle = {
		...(props.actions ? {
			paddingBottom: '120px',
		} : {}),
	};

	return (
		<>
			<MuiDialog {...dialogProps} className={`${dialogProps.className ? dialogProps.className : ''} ${props.variant}`} onClose={handleOnClose}>
				<div className="Dialog-titleBar">
					{ props.title && <DialogTitle>{props.title}</DialogTitle> }
					<div className="Dialog-titleButtonRow">
						{ props.titleButtons?.length && <>{props.titleButtons}</> }
						<Button onClick={handleClose} disableRipple variant="icon" aria-label="Close"><Close /></Button>
					</div>
				</div>
				<DialogContent style={inlineStyle}>
					<DialogContentText component="div">
						{props.children}
					</DialogContentText>
				</DialogContent>
				{ props.actions && <DialogActions>{props.actions}</DialogActions> }
			</MuiDialog>
		</>
	)
}

export default Dialog;